export const STUDENT = 'STUDENT';
export const SCHOOL = 'SCHOOL';
export const SL = 'SL';
export const TEACHER = 'TEACHER';
export const NULL = 'null';
export const ROLES = {
  STUDENT,
  SCHOOL,
  SL,
  TEACHER,
  NULL
};
export const API_ROLES = (() => {
  let ret = {};
  for (let key in ROLES) {
    let role = ROLES[key];
    ret[role] = role.toLowerCase();
  }
  return ret;
})();
export const LOGIN_LAST_TYPE_KEY = 'KEY_HSYLC2021_LAST_LOGIN_TYPE';
export const LOGIN_DATA_KEYS = (() => {
  let ret = {};
  for (let key in ROLES) {
    let role = ROLES[key];
    ret[role] = `KEY_HSYLC2021_${role}_LOGIN_DATA`;
  }
  return ret;
})();
export const URL_KEYS = (() => {
  let ret = {};
  for (let key in ROLES) {
    let role = ROLES[key];
    let sRole = role.toLowerCase();
    ret[role] = new RegExp(`/${sRole}/`);
  }
  ret[ROLES.STUDENT] = /\/student\/|\/activity\/|\/region\/countries|\/bury-dot|\/ddls/;
  ret[ROLES.TEACHER] = /(\/teacher\/)|(\/api\/admin\/)/;
  return ret;
})();
/**
 * 1. SL （英文授课人）
 * 2. TF （课程助教）
 * 3. CSL （中文授课人）
 * 4. STAFF（SL/CSL有House）
 *   - 以上账号编号对应hsylc_teacher表中的type字段
 *   - 今年的SL/CSL/TF 都有house
 *   - 每个授课人(SL/CSL）都将对应一个 TF
 */
export const USER_TYPES = {
  TEACHER: 1,
  TF: 2,
  CSL: 3,
  STAFF: 4,
  ADMIN: 9
};
